import { PhoneIcon } from "@heroicons/react/24/outline";

type Contact = {
  phone: string;
  email: string;
};

export default function ContactCard({ contact }: { contact: Contact }) {
  return (
    <section className="overflow-hidden rounded-xl border border-gray-100 bg-white">
      <div className="flex items-center gap-2 border-b border-gray-100 px-4 md:px-5 py-4.5">
        <PhoneIcon className="size-5 text-blue-600" />
        <h2 className="text-sm md:text-base font-medium text-gray-950">
          Contact
        </h2>
      </div>

      <div className="flex flex-col px-4 md:px-5 py-1.5 text-sm">
        <div className="flex items-center justify-between gap-4 border-b border-gray-100 py-3.5">
          <span className="shrink-0 text-gray-500">Phone</span>
          <span className="min-w-0 break-all text-right text-gray-950">
            {contact.phone}
          </span>
        </div>
        <div className="flex items-center justify-between gap-4 py-3.5">
          <span className="shrink-0 text-gray-500">Email</span>
          <span className="min-w-0 break-all text-right text-gray-950">
            {contact.email}
          </span>
        </div>
      </div>
    </section>
  );
}
